import { msg } from "@lingui/core/macro";
import { createRoute } from "@tanstack/solid-router";
import { appRoute } from "./route";
import { AuthPlaceholder } from "@/components/auth-placeholder";
import { PageContainer } from "@fleet/ui/page-container";
import { CalendarPage } from "@/features/domain/components/calendar-page";
import { useI18n } from "@/providers/i18n-provider";

function CalendarRoutePage() {
  const { t } = useI18n();
  return (
    <AuthPlaceholder
      title={t(msg`Calendar`)}
      description={t(msg`Sign in to see the global calendar.`)}
    >
      <PageContainer maxWidth="3xl">
        <CalendarPage />
      </PageContainer>
    </AuthPlaceholder>
  );
}

export const calendarRoute = createRoute({
  getParentRoute: () => appRoute,
  path: "/calendar",
  component: CalendarRoutePage,
});
